
namespace GeniuzPOS.Product {

    @Serenity.Decorators.registerClass()
    export class ReportExportV1Dialog extends Serenity.EntityDialog<ReportExportV1Row, any> {
        protected getFormKey() { return ReportExportV1Form.formKey; }
        protected getIdProperty() { return ReportExportV1Row.idProperty; }
        protected getLocalTextPrefix() { return ReportExportV1Row.localTextPrefix; }
        protected getNameProperty() { return ReportExportV1Row.nameProperty; }
        protected getService() { return ReportExportV1Service.baseUrl; }
        protected getDeletePermission() { return ReportExportV1Row.deletePermission; }
        protected getInsertPermission() { return ReportExportV1Row.insertPermission; }
        protected getUpdatePermission() { return ReportExportV1Row.updatePermission; }

        protected form = new ReportExportV1Form(this.idPrefix);

    }
}